import axios from "./_axios";
import { API } from "./apiEndPoints";

// ER-10479: account-level Market Data files (ER-10478 backend).
const marketDataFilesUrl = (accountId) => `${API.MARKET_DATA_FILES}${accountId}/market-data-files/`;

export const getMarketDataFiles = (accountId) => {
  return axios()({
    method: "get",
    url: marketDataFilesUrl(accountId),
  });
};

export const uploadMarketDataFiles = (accountId, files, onUploadProgress) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("files", file));

  return axios()({
    method: "post",
    url: marketDataFilesUrl(accountId),
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

export const deleteMarketDataFile = (accountId, fileId) => {
  return axios()({
    method: "delete",
    url: `${marketDataFilesUrl(accountId)}${fileId}/`,
  });
};

// Maps EntityContextFileSerializer → { id, name } for ContextFiles.vue.
export const mapMarketDataFileToUi = (file) => ({
  id: file.id,
  name: file.file_name,
});
